import { Link } from "react-router-dom";
import { Download, FileText, BookMarked, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { waLink } from "@/lib/brand";

const groups = [
  { icon: "📘", title: "Chapter-wise Notes", subtitle: "Class VI – X" },
  { icon: "📝", title: "Sample Papers & Mock Tests", subtitle: "CBSE & ICSE" },
  { icon: "📄", title: "Previous Year Papers", subtitle: "Last 10 years" },
  { icon: "📐", title: "Formula & Revision Sheets", subtitle: "Quick recall" },
  { icon: "🧪", title: "Practical & Lab Guides", subtitle: "Science" },
];

const downloads = [
  { subject: "Mathematics", cls: "VI – VIII" },
  { subject: "Mathematics", cls: "IX – X" },
  { subject: "Science", cls: "VI – VIII" },
  { subject: "Science (Physics/Chem/Bio)", cls: "IX – X" },
  { subject: "English", cls: "VI – X" },
  { subject: "Social Studies", cls: "VI – X" },
  { subject: "Hindi", cls: "VI – X" },
  { subject: "Sample Papers", cls: "Class X Boards" },
];

export default function StudyMaterialsPage() {
  const handleDownload = (item) => {
    toast.info("Notes coming soon", {
      description: `The ${item.subject} (${item.cls}) pack will be available shortly. WhatsApp us to receive it directly.`,
    });
  };

  return (
    <div>
      <section className="bg-[#0B192C] text-white relative overflow-hidden">
        <div className="vk-grain" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <span className="vk-chip">Free resources</span>
          <h1 className="mt-4 font-display text-5xl sm:text-6xl font-800 tracking-tight max-w-3xl">Free study materials &amp; notes.</h1>
          <p className="mt-5 max-w-2xl text-lg text-white/70">Learning shouldn&apos;t stop when class ends. Download our curated notes, sample papers and formula sheets — free for every student.</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display text-3xl font-800 text-[#0B192C]">What you&apos;ll find here</h2>
          <div className="mt-8 grid grid-cols-2 md:grid-cols-5 gap-4">
            {groups.map((g)=>(
              <div key={g.title} className="rounded-lg border border-slate-200 p-5 text-center">
                <div className="text-3xl">{g.icon}</div>
                <div className="mt-3 font-display font-bold text-[#0B192C] text-sm">{g.title}</div>
                <div className="text-xs text-slate-500 mt-1">{g.subtitle}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
            <div>
              <span className="vk-chip">Downloads</span>
              <h2 className="mt-4 font-display text-4xl font-800 text-[#0B192C]">Notes &amp; papers</h2>
            </div>
            <a href={waLink("Hi, I'd like to request study notes on WhatsApp.")} target="_blank" rel="noreferrer" className="vk-btn-dark text-sm">Request via WhatsApp <ArrowRight size={16} /></a>
          </div>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {downloads.map((d,i)=>(
              <button
                key={i}
                data-testid={`download-${i}`}
                onClick={() => handleDownload(d)}
                className="text-left rounded-lg bg-white border border-slate-200 p-5 hover:border-[#FF6B35] transition-colors group"
              >
                <FileText size={20} className="text-[#FF6B35]" />
                <div className="mt-4 font-display text-lg font-bold text-[#0B192C]">{d.subject}</div>
                <div className="text-sm text-slate-500">{d.cls}</div>
                <div className="mt-4 flex items-center gap-2 text-sm font-semibold text-[#0B192C] group-hover:text-[#FF6B35]">
                  <Download size={16} /> Download Notes
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 rounded-lg border border-slate-200 p-10 text-center bg-[#0B192C] text-white relative overflow-hidden">
          <div className="vk-grain" />
          <div className="relative">
            <BookMarked size={28} className="text-[#FF6B35] mx-auto" />
            <h2 className="mt-4 font-display text-3xl font-800">Want personalised guidance?</h2>
            <p className="mt-2 text-white/70">Book a free demo with our team and get a study plan tailored to your child.</p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <Link to="/contact" className="vk-btn-primary">Book Free Demo <ArrowRight size={16} /></Link>
              <a href={waLink()} target="_blank" rel="noreferrer" className="vk-btn-outline">WhatsApp Now</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
